const PDFToolbar = Toolbar => (
  <Toolbar>
    {slots => {
      const { CurrentPageLabel, NumberOfPages, Zoom, ZoomIn, ZoomOut } = slots;
      return (
        <div
          style={{
            alignItems: 'center',
            display: 'flex'
          }}
        >
          <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
            <ZoomOut />
          </div>
          <div style={{ padding: '0px 2px' }}>
            <Zoom />
          </div>
          <div style={{ padding: '0px 2px' }}>
            <ZoomIn />
          </div>
          <div style={{ padding: '0px 2px', marginRight: 'auto' }}>
            <CurrentPageLabel />
            /
            <NumberOfPages />
          </div>
        </div>
      );
    }}
  </Toolbar>
);

export default PDFToolbar;
